import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useAuth } from './AuthContext';

const SettingsContext = createContext();

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};

export const SettingsProvider = ({ children }) => {
    const { currentUser } = useAuth();
    const [settings, setSettings] = useState({
        customHead: '',
        customBody: '',
        faviconUrl: '',
        snsShareImageUrl: '',
    });

    useEffect(() => {
        if (!currentUser) return;

        const unsubscribe = onSnapshot(
            doc(db, 'settings', currentUser.uid),
            (doc) => {
                if (doc.exists()) {
                    setSettings(doc.data());
                }
            },
            (error) => {
                console.error('設定の監視に失敗しました:', error);
            }
        );

        return () => unsubscribe();
    }, [currentUser]);

    return (
        <SettingsContext.Provider value={settings}>
            {children}
        </SettingsContext.Provider>
    );
}; 